var stringComparer = function (str1, str2) {
    if (!str2) {
        return true;
    }
    if (!str1) {
        return false;
    }
    return str1.toUpperCase().includes(str2.toUpperCase());
};
export { stringComparer };



//////////////////
// WEBPACK FOOTER
// ./src/utils/comprasion.ts
// module id = 197
// module chunks = 0